module.exports = __webpack_public_path__ + "img/logo.ef93fae7.png";